import { NoveltyCalcLaunchStatusFilter, type NoveltyCalcRequest } from '@/api';
import type { DefaultOptionType } from '@/components/combobox/combobox';
import LeftSidePanel from '@/components/left-side-panel';
import SummaryRow from '@/pages/price-planning/copy-price-page/components/summary-row';
import ConditionsSection from './conditions-section';

type PriceCalcSummaryPanelProps = {
  form: NoveltyCalcRequest;
  selectedPriceUnits: DefaultOptionType[];
  onBackArrowClick: () => void;
};

const PriceCalcSummaryPanel = ({
  form,
  selectedPriceUnits,
  onBackArrowClick,
}: PriceCalcSummaryPanelProps) => {
  const currentYear = new Date().getFullYear();
  const nextYear = currentYear + 1;

  return (
    <LeftSidePanel
      title={'Price Calculator'}
      showBackArrow
      onBack={onBackArrowClick}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '24px',
          width: '100%',
        }}
      >
        <SummaryRow
          label="Year"
          value={
            form.planningYear === nextYear
              ? `Next (${nextYear})`
              : `Current (${currentYear})`
          }
        />
        <SummaryRow
          label="Local Price List"
          value={selectedPriceUnits[0]?.label || 'N/A'}
        />
        <ConditionsSection
          priceUnitId={Number(selectedPriceUnits[0]?.id)}
          year={form.planningYear}
        />
        <SummaryRow
          label="Status"
          value={
            form.launchStatusFilter === NoveltyCalcLaunchStatusFilter.All
              ? 'All Novelties'
              : form.launchStatusFilter ===
                  NoveltyCalcLaunchStatusFilter.FirstHalf
                ? '1HY'
                : '2HY'
          }
        />
        <SummaryRow
          label="Overwrite preliminary prices"
          value={form.overwritePreliminaryPrices ? 'Yes' : 'No'}
        />
      </div>
    </LeftSidePanel>
  );
};

export default PriceCalcSummaryPanel;
